/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AttributeValueForString extends models.AttributeValueBase {
    constructor() {
        super();
        this.setDiscriminator("AttributeValueForString");
    }

    getFixupPrototypeFunction() { return AttributeValueForString.fixupPrototype; }

    static newInstance(model: Partial<AttributeValueForString>): AttributeValueForString {
        let obj = Object.assign(new AttributeValueForString(), model);
        AttributeValueForString.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AttributeValueForString>): AttributeValueForString {
        if (!model) return null;
        return AttributeValueForString.newInstance(<AttributeValueForString> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AttributeValueForString) {
        if (!obj) return;

        models.AttributeValueForString.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AttributeValueForString): boolean {
        if (models.AttributeValueBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AttributeValueForString.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Values for the Attribute
     */
    values: Array<string>;

}
